import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { ZoomIn, ZoomOut, RotateCcw } from "lucide-react";
import { LOTS, LOT_PLAN_URL } from "../data/lots";

const isMobile = typeof window !== "undefined" && window.matchMedia("(max-width: 640px)").matches;

const LotPins = ({ onPinClick }) => (
  <>
    {LOTS.map((lot) => (
      <button
        key={lot.id}
        data-testid={`lot-plan-${lot.id}-marker`}
        onClick={() => onPinClick(lot)}
        style={{ left: lot.pin.left, top: lot.pin.top }}
        className={`absolute -translate-x-1/2 -translate-y-1/2 group z-10 p-1 ${lot.status === "Sold" ? "cursor-default" : "cursor-pointer"}`}
        aria-label={`${lot.name} ${lot.status}`}
      >
        <span
          className={`flex items-center justify-center w-11 h-11 sm:w-9 sm:h-9 rounded-full border-2 font-sans text-[11px] sm:text-[10px] font-semibold tracking-tight transition-transform [transition-duration:300ms] group-hover:scale-110 ${
            lot.status === "Sold"
              ? "bg-neutral-500/90 border-white/70 text-white"
              : "bg-brass border-white text-forest animate-pin-pulse"
          }`}
        >
          {lot.name.replace("Lot ", "")}
        </span>
        {lot.status === "Sold" && (
          <span className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-forest text-cream text-[9px] font-sans font-semibold tracking-[0.15em] px-2 py-0.5 rounded-sm">
            SOLD
          </span>
        )}
      </button>
    ))}
  </>
);

const ctrlCls = "bg-forest/90 text-cream p-3 sm:p-2.5 rounded-sm hover:bg-forest transition-colors duration-300";

export const PlanCanvas = ({ onPinClick, compact = false }) => (
  <TransformWrapper
    initialScale={1}
    minScale={isMobile ? 0.4 : 0.6}
    maxScale={5}
    centerOnInit
    doubleClick={{ mode: "zoomIn" }}
    pinch={{ step: 5 }}
    wheel={{ step: 0.08, disabled: compact }}
    panning={{ disabled: compact && isMobile }}
  >
    {({ zoomIn, zoomOut, resetTransform }) => (
      <div className={`relative ${compact && isMobile ? "" : "touch-none"}`}>
        <div className="absolute top-3 right-3 sm:top-4 sm:right-4 z-20 flex gap-2">
          <button data-testid="lot-plan-zoom-in" onClick={() => zoomIn()} className={ctrlCls} aria-label="Zoom in">
            <ZoomIn size={18} />
          </button>
          <button data-testid="lot-plan-zoom-out" onClick={() => zoomOut()} className={ctrlCls} aria-label="Zoom out">
            <ZoomOut size={18} />
          </button>
          <button data-testid="lot-plan-reset" onClick={() => resetTransform()} className={ctrlCls} aria-label="Reset view">
            <RotateCcw size={18} />
          </button>
        </div>
        <TransformComponent wrapperClass="!w-full" contentClass="!w-full">
          <div className="relative w-full">
            <img src={LOT_PLAN_URL} alt="Woodlake Estates lot plan survey" className="w-full h-auto select-none" draggable={false} />
            <LotPins onPinClick={onPinClick} />
          </div>
        </TransformComponent>
      </div>
    )}
  </TransformWrapper>
);
